import { CommentState, commentReducer } from "./commentReducer"
import { CompanySearchState, companySearchReducer } from "./companySearchReducer"
import { IDigitealStoreAddition, digitealSlice } from "./digitealSlice"
import { IKycStoreAddition, kycSlice } from "./kycSlice"
import { ModalState, modalReducer } from "./modalReducer"
import { OrganizationState, organizationReducer } from "./organizationReducer"
import { IProviderStoreAddition, providerSlice } from "./providerSlice"
import { SharedConfigurationState, sharedConfigurationReducer } from "./sharedConfigurationReducer"
import { ISwMerchantStoreAddition, swMerchantSlice } from "./swMerchantSlice"
import { UserState, userReducer } from "./userReducer"

export type SharedStoreState = {
    sharedConfiguration: SharedConfigurationState
    companySearch: CompanySearchState
    modal: ModalState
    organizations: OrganizationState
    user: UserState
    comment: CommentState
} & ISwMerchantStoreAddition &
    IKycStoreAddition &
    IProviderStoreAddition &
    IDigitealStoreAddition

export const getSharedRootReducer = () => ({
    sharedConfiguration: sharedConfigurationReducer,
    companySearch: companySearchReducer,
    modal: modalReducer as any, // any to counter type error for mixing TModals and TAllSharedModals
    organizations: organizationReducer,
    user: userReducer,
    comment: commentReducer,
    swMerchant: swMerchantSlice.reducer,
    kyc: kycSlice.reducer,
    providers: providerSlice.reducer,
    digiteal: digitealSlice.reducer,
})
